module.exports = __webpack_public_path__ + "static/galuskova-0fcaee776327c750363af0e44a091186.jpg";